import { c as _c } from "react/compiler-runtime";
/* eslint-disable i18next/no-literal-string */
import { NormalizedCacheObject } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';
import { ReactElement } from 'react';
import { renderToString } from 'react-dom/server';
import { InstantSearch, InstantSearchSSRProvider, InstantSearchServerState, getServerState } from 'react-instantsearch';
import { useInstantSearchClient } from '@core/journeys/ui/algolia/InstantSearchProvider';
import i18nConfig from '../../next-i18next.config';
import { ResourcesView } from '../../src/components/ResourcesView';
import { indexes } from '../../src/components/ResourcesView/ResourceSections/ResourceSections';
import { createInstantSearchRouter } from '../../src/libs/algolia/instantSearchRouter/instantSearchRouter';
import { createApolloClient, useApolloClient } from '../../src/libs/apolloClient';
import { getFlags } from '../../src/libs/getFlags';
interface ResourcesPageProps {
  intitialApolloState?: NormalizedCacheObject;
  serverState?: InstantSearchServerState;
}
function ResourcesPage(t0) {
  const $ = _c(13);
  const {
    intitialApolloState,
    serverState
  } = t0;
  let t1;
  if ($[0] !== intitialApolloState) {
    t1 = {
      initialState: intitialApolloState
    };
    $[0] = intitialApolloState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const client = useApolloClient(t1);
  const searchClient = useInstantSearchClient();
  const baseUrl = (process.env.NEXT_PUBLIC_WATCH_URL ?? "").replace("/watch", "");
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = createInstantSearchRouter({
      indexName: indexes[0],
      serverUrl: `${baseUrl}/resources`
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const nextRouter = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      preserveSharedStateOnUnmount: true
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ResourcesView />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== searchClient) {
    t5 = <InstantSearch searchClient={searchClient} indexName={indexes[0]} future={t3} stalledSearchDelay={500} insights={true} routing={nextRouter}>{t4}</InstantSearch>;
    $[5] = searchClient;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== client || $[8] !== t5) {
    t6 = <ApolloProvider client={client}>{t5}</ApolloProvider>;
    $[7] = client;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== serverState || $[11] !== t6) {
    t7 = <InstantSearchSSRProvider {...serverState}>{t6}</InstantSearchSSRProvider>;
    $[10] = serverState;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
export const getStaticProps: GetStaticProps<ResourcesPageProps> = async ({
  locale
}) => {
  const flags = await getFlags();
  if (flags.strategies !== true) return {
    revalidate: 60,
    redirect: {
      destination: '/',
      permanent: false
    }
  };
  const serverState = await getServerState(<ResourcesPage />, {
    renderToString
  });
  const apolloClient = createApolloClient();
  return {
    revalidate: 3600,
    props: {
      flags,
      serverState,
      intitialApolloState: apolloClient.cache.extract() as NormalizedCacheObject,
      ...(await serverSideTranslations(locale ?? 'en', ['apps-resources'], i18nConfig))
    }
  };
};
export default ResourcesPage;